<mat-dialog-content>
  @if (message) {
    <p> {{message}} </p>
  }
  @if (type !== 'hint' && type !== 'warn') {
    <form [formGroup]="eventForm" class="form">
      <mat-form-field class="form-element">
        <mat-label>Note</mat-label>
        <input matInput placeholder="Note" formControlName="note">
      </mat-form-field>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (type !== 'hint') {
    <button mat-raised-button mat-dialog-close> Cancel </button>
  }
  @if (type === 'switch' || type === 'hint' || type === 'warn') {
    <button mat-raised-button color="primary"
      (click)="onConfirmClick()">
    Confirm </button>
  }
  @if (type === 'confirm') {
    <button mat-raised-button color="primary" [mat-dialog-close]="eventForm.getRawValue()">
    Confirm </button>
  }
</mat-dialog-actions>